<template>
    <div class="flex items-center justify-center w-full h-full">
        <div class="flex items-center">
            <img src="@/assets/hermes.png">
            <h1 class="text-5xl ">
                {{ $t('pageNotFound') }}
            </h1>
        </div>
    </div>
</template>

<script>
export default {

};
</script>

<style>
.ant-layout-content {
    height: 100%;
}
</style>